import type { MouseEvent } from "react";

import { useBodyScrollLock } from "@partners/ui";
import { Button, Modal, Typo } from "@pepperstone/pepper-ui-kit";

type StillBrowsingModalProps = {
  header: string;
  body: string;
  continueButtonLabel: string;
  onClickContinue?: (event: MouseEvent<HTMLButtonElement>) => void;
  logoutButtonLabel: string;
  onClickLogout?: (event: MouseEvent<HTMLButtonElement>) => void;
  showModal: boolean;
};

export const StillBrowsingModal = ({
  header,
  body,
  continueButtonLabel,
  onClickContinue,
  logoutButtonLabel,
  onClickLogout,
  showModal,
}: StillBrowsingModalProps) => {
  useBodyScrollLock(showModal);

  return (
    <Modal
      content={
        <>
          <Typo elem="h1" size="lg" type="heading">
            {header}
          </Typo>
          <Typo elem="p" responsiveClasses="pb-5" size="md" type="body">
            {body}
          </Typo>
          <div className="mb-2">
            <Button
              type="button"
              className="w-full"
              variant="ps-btn-primary"
              onClick={onClickContinue}
            >
              {continueButtonLabel}
            </Button>
          </div>
          <Button
            type="button"
            className="w-full"
            variant="ps-btn-secondary"
            onClick={onClickLogout}
          >
            {logoutButtonLabel}
          </Button>
        </>
      }
      isVisible={showModal}
      position="center"
      size="normal"
      maxHeight={376}
      maxWidth={602}
    />
  );
};
